export default "__VITE_ASSET__e0c0a73c__"